import React from 'react';
import { Link } from 'react-router-dom';
import { useFirmMode } from '../contexts/FirmModeContext';

/**
 * Renders children only when firm mode is active.
 * When not in firm mode, shows a message and link to home (no Arsheef/cases UI exposed).
 */
const FirmProtectedRoute = ({ children }) => {
  const { isFirmMode, firmCheckDone } = useFirmMode();

  if (!firmCheckDone) {
    return (
      <div className="firm-route-loading" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40vh',
        padding: '2rem',
      }}>
        <span style={{ color: '#64748b', fontSize: '1rem' }}>Loading...</span>
      </div>
    );
  }

  if (!isFirmMode) {
    return (
      <div className="firm-route-required" style={{
        maxWidth: '480px',
        margin: '2rem auto',
        padding: '2rem',
        textAlign: 'center',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}>
        <p style={{ marginBottom: '1rem', color: '#475569' }}>
          This page is only available when you are signed in through your firm (Arsheef).
        </p>
        <Link to="/home" style={{ color: '#6366f1', fontWeight: 500 }}>
          Go to Home
        </Link>
      </div>
    );
  }

  return children;
};

export default FirmProtectedRoute;
